// 工单处理-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane :label="$t('common.routine')" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :dealType="orderDealType" :siteDeal="true"
          :parent-target="_self" @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"
          @flushPage="getTableData" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.list')" name="second">

        <div style=" height: calc(100vh + -81px);">
          <div class="box">

          <div class="box1">
            <div class="box1_item1"> 预约及时率 90%</div>
            <div class="box1_item2">
              <div class="box1_item2_title1 box1_item2_title">180</div>
              <div class="box1_item2_title2 box1_item2_title">15</div>
              <div class="box1_item2_title3 box1_item2_title">5</div>
            </div>
          </div>

          <div class="box1">
            <div class="box1_item1"> 上门及时率 95.5%</div>
            <div class="box1_item2">
              <div class="box1_item2_title1 box1_item2_title">190</div>
              <div class="box1_item2_title2 box1_item2_title">12</div>
              <div class="box1_item2_title3 box1_item2_title">7</div>
            </div>
          </div>  
            <div class="box1">
            <div class="box1_item1"> 完工及时率 88.9%</div>
            <div class="box1_item2">
              <div class="box1_item2_title1 box1_item2_title">320</div>
              <div class="box1_item2_title2 box1_item2_title">30</div>
              <div class="box1_item2_title3 box1_item2_title">10</div>
            </div>
          </div>

   

          </div>

          <vxe-grid show-overflow :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption" height="100%"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="soOrderImport" status="primary" class="button-sty" icon="el-icon-bottom"
                    @click="$refs.excelUpload.show()">{{$t('center.WorkOrderImport')}}
                  </vxe-button>
                  <vxe-button v-if="soOrderExport" status="primary" class="button-sty" icon="el-icon-top"
                    @click="doExcle">{{$t('center.WorkOrderExport')}}
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <div style="margin-right:15px">

                    <el-button v-if="orderClose && isShowClose" type="primary" plain class="button-sty"
                               @click="bathOrderClose" icon="el-icon-location-information">{{$t('common.BatchShutdown')}}
                    </el-button>

                    <el-button v-if="assignSecondSite && isSite && isShowAssignSecondSite && bigSiteId" type="primary" plain class="button-sty"
                               @click="batchAssignSecondSite" icon="el-icon-location-information">{{$t('common.BatchAssignSecondSite')}}
                    </el-button>

                    <el-button v-if="printOrder" type="primary" plain class="button-sty"
                               @click="doPrints" icon="el-icon-location-information">{{$t('common.BatchPrinting')}}
                    </el-button>
                    <el-button v-if="assignSites && isShowAssign" type="primary" plain class="button-sty"
                      @click="doAssignSites" icon="el-icon-s-grid">{{$t('center.assignOrder')}}
                    </el-button>
                    <el-button v-if="assignSiteByMap && isShowAssign" type="primary" plain class="button-sty"
                      @click="doAssignSitesByMay" icon="el-icon-location-information">{{$t('center.cartographer')}}
                    </el-button>
                    <el-button v-if="acceptOrder && isShowAccept" type="primary" plain class="button-sty"
                      @click="siteAccepts" icon="el-icon-location-information">{{$t('center.BulkOrder')}}
                    </el-button>
                  </div>
                  <div class="fr" style="display: flex;position: relative;">
                  <el-input  type="textarea"
                             :autosize="{ minRows: 1, maxRows: 8}"  style="width: 200px;     height: 27px !important; "
                             v-model="formData.orderNoArr" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                    @click="searchEvent">{{$t('common.search')}}
                  </vxe-button>
                  <div style="display: flex;margin-top: 5px;margin-right: 5px;color: #409eff;" @click="show3 = !show3">
                    <svg t="1682558973727" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="1587" width="16" height="16">
                      <path
                        d="M921.6 686.08h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m0-122.88h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m-166.4-289.28c-2.56 2.56-243.2 227.84-243.2 227.84v389.12l-163.84-81.92v-307.2L112.64 281.6c-2.56-2.56-5.12-5.12-7.68-5.12-15.36-15.36-23.04-35.84-23.04-58.88 0-46.08 38.4-84.48 84.48-84.48h527.36c46.08 0 84.48 38.4 84.48 84.48 0 23.04-10.24 43.52-23.04 56.32zM693.76 179.2H166.4C145.92 179.2 128 197.12 128 217.6c0 10.24 2.56 20.48 10.24 25.6l2.56 2.56 227.84 215.04 15.36 12.8 2.56 25.6-2.56 273.92 81.92 40.96V473.6l15.36-12.8 230.4-212.48 2.56-2.56c7.68-7.68 10.24-15.36 10.24-25.6 7.68-23.04-10.24-40.96-30.72-40.96z m-17.92 588.8H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48h-245.76c-10.24 0-20.48-10.24-20.48-20.48 0-12.8 7.68-20.48 20.48-20.48z"
                        fill="#0ea2f0" p-id="1588"></path>
                    </svg>
                    <span>{{$t('common.MoreScreening')}}</span>
                  </div>
                  </div>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form v-show="show3" ref="form" class="screen-box" title-width="7vw" title-align="right"
                  :data="formData" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item :title="$t('common.WorkOrderStatus')+':'" field="name">
                    <template v-slot>
                      <el-select v-model="formData.stat" :disabled="requestParam.tabStat !== '所有'" clearable
                        style="width:9vw ;">
                        <!--                        <el-option :value="null" label="全部"></el-option>-->
                        <el-option :value="1" :label="$t('common.SignIn')"></el-option>
                        <el-option :value="2" :label="$t('common.publish')"></el-option>
                        <el-option :value="5" :label="$t('common.DispatchedNetwork')"></el-option>
                        <el-option :value="6" :label="$t('common.TheNetworkReceivedOrders')"></el-option>
                        <el-option :value="9" :label="$t('common.DispatchedMaster')"></el-option>
                        <el-option :value="10" :label="$t('common.MasterHasAcceptedOrder')"></el-option>
                        <el-option :value="11" :label="$t('common.HaveAlreadyReserved')"></el-option>
                        <el-option :value="13" :label="$t('common.HaveSetOut')"></el-option>
                        <el-option :value="17" :label="$t('common.HaveBeenDoor')"></el-option>
                        <el-option :value="20" :label="$t('common.CompletedTemporaryHold')"></el-option>
                        <el-option :value="30" :label="$t('common.ShippingRepairConfirmed')"></el-option>
                        <el-option :value="31" :label="$t('common.ToBeSent')"></el-option>
                        <el-option :value="32" :label="$t('common.HasBeenSignature')"></el-option>
                        <el-option :value="36" :label="$t('common.ToBeRepaired')"></el-option>
                        <el-option :value="37" :label="$t('common.RepairedToShip')"></el-option>
                        <el-option :value="38" :label="$t('common.CustomerToBeSigned')"></el-option>
                        <el-option :value="40" :label="$t('common.ReturnTBeConfirmed')"></el-option>
                        <el-option :value="41" :label="$t('common.OldMachineReturned')"></el-option>
                        <el-option :value="42" :label="$t('common.OldMachineSigned')"></el-option>
                        <el-option :value="43" :label="$t('common.TheOldMachineSigned')"></el-option>
                        <el-option :value="44" :label="$t('common.NewMachinesShipped')"></el-option>
                        <el-option :value="45" :label="$t('common.NewMachinesSent')"></el-option>
                        <el-option :value="47" :label="$t('common.NewMachineTSigned')"></el-option>

                        <el-option :value="48" :label="$t('common.TheMachineSignedFor')"></el-option>
                        <el-option :value="49" :label="$t('common.TheExchangeRejected')"></el-option>
                        <el-option :value="61" :label="$t('common.completed')"></el-option>
                        <el-option :value="62" :label="$t('common.NetworkConfirmationCompletion')"></el-option>
                        <el-option :value="63" :label="$t('common.CenterCompletionAudit')"></el-option>
                        <el-option :value="64" :label="$t('common.HeadquartersCompletionAudit')"></el-option>
                        <el-option :value="91" :label="$t('common.ToBeSettled')"></el-option>
                        <el-option :value="92" :label="$t('common.RejectionSettlement')"></el-option>
                        <el-option :value="93" :label="$t('common.SettlementSuspension')"></el-option>
                        <el-option :value="94" :label="$t('common.HaveAlreadySettled')"></el-option>
                        <el-option :value="97" :label="$t('common.ApplyForClosure')"></el-option>
                        <el-option :value="98" :label="$t('common.HangUp')"></el-option>
                        <el-option :value="99" :label="$t('common.cancel')"></el-option>
                        <el-option :value="100" :label="$t('common.finish')"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.userName')+':'" field="name">
                    <template v-slot>
                      <el-input v-model="formData.userName" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item :title="$t('common.ServiceType')+':'" field="name">
                    <template v-slot>
                      <service-type-cascader style="width:9vw;"
                        @selectedServiceType="data => { formData.serviceTypeId = data }" />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.ServiceBrand')+':'" field="name">
                    <template v-slot>
                      <brand-select style="width:9vw;" :brand-id.sync="formData.brandId" />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.CreationTime')+':'" field="name">
                    <template v-slot >
                      <el-date-picker style="width: 17vw;" v-model="formData.createDate" type="daterange" align="right"
                        unlink-panels range-separator="-"
                        :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.PartStatus')+':'" field="name">
                    <template v-slot>
                      <el-select v-model="formData.partsStat" clearable style="width:9vw ;">
                        <!--                        <el-option :value="null" label="全部"></el-option>-->
                        <el-option :value="0" label="无配件"></el-option>
                        <el-option :value="1" label="申请"></el-option>
                        <el-option :value="2" label="审核"></el-option>
                        <el-option :value="3" label="出库"></el-option>
                        <el-option :value="4" label="网点收货"></el-option>
                        <el-option :value="8" label="驳回"></el-option>
                        <el-option :value="9" label="取消"></el-option>
                        <el-option :value="11" label="更换"></el-option>
                        <el-option :value="12" label="网点返厂"></el-option>
                        <el-option :value="13" label="返厂确认"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.ServiceCenter')+':'" field="name">
                    <org-search :org-name.sync="formData.orgName" :org-id-path.sync="formData.orgIdPath"
                      :org-id.sync="formData.orgId" :show="!isSite" style="width:9vw ;" />
                  </vxe-form-item>

                  <vxe-form-item :title="$t('common.ServiceProvider')+':'" field="name">
                    <template v-slot>
                      <site-search :site-id.sync="formData.siteId" :show="!isSite" style="width:9vw ;" />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.founder')+':'" field="name">
                    <template v-slot>
                      <el-input v-model="formData.createBy" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.AppointmentTime')+':'" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="formData.bookDate" type="daterange" align="right"
                        unlink-panels range-separator="-"
                        :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.WorkOrderLabel')+':'" field="name">
                    <template v-slot>
                      <dispatch-stat-select style="width:9vw;" :dispatch-stat.sync="formData.dispatchStat" />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.SourceWorkOrder')+':'" field="name">
                    <template v-slot>
                      <order-type-select style="width:9vw;" :order-type-id.sync="formData.orderTypeId" />
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.WarrantyType')+':'" field="name">
                    <template v-slot>
                      <el-select v-model="formData.guaranteeType" style="width:9vw ;" clearable>
                        <!--                        <el-option :value="null" label="全部"></el-option>-->
                        <el-option :value="1" label="保内"></el-option>
                        <el-option :value="2" label="保外"></el-option>
                        <el-option :value="3" label="未知"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.ExternalOrderNumber')+':'" field="name">
                    <template v-slot>
                      <el-input v-model="formData.outOrderNo" size="small" clearable style="width:9vw ;" />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item :title="$t('common.TimeCompletion')+':'" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="formData.completeDate" type="daterange" align="right"
                        unlink-panels range-separator="-"
                        :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item :title="$t('common.district')+':'" field="name">
                    <template v-slot>
                      <el-cascader :props="areaProps" v-model="formData.areaId" :clearable="true" style="width:9vw ;"
                        @change="handleAreaChange" ref="cascaderAddr" />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item v-if="isSite" :title="$t('common.Engineer')+':'" field="name">
                    <template v-slot>
                      <div style="width:9vw;">
                        <el-select v-model="formData.engineerId" @change="engineerSelectChang" clearable size="small" filterable>
                          <el-option v-for="item in engineerList" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                        </el-select>
                      </div>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item v-else :title="$t('common.overseer')+':'" field="name">
                    <template v-slot>
                      <el-input v-model="formData.managerName" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item :title="$t('common.FinishedBarCode')+':'" field="name">
                    <template v-slot>
                      <el-input v-model="formData.resultBarcode" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item :title="$t('common.NumberReminders')+':'" field="name">
                    <template v-slot>
                      <el-input v-model="formData.urgeTimesBegin" class="priceInput" style="width: 4vw" clearable/><span
                      style="display: inline-block;width:1vw;text-align: center;">-</span><el-input
                      v-model="formData.urgeTimesEnd" class="priceInput" ref="prodEnd" style="width:4vw;" clearable/>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
                    btnGoodsStatusBt1: goodsStatusIndex == index,
                    btnGoodsStatusBt: goodsStatusIndex != index
                  }" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span v-if="item.name != '所有'" class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #showSiteComplainStat="{ row }">
              <span class="txt-status " v-if="row.siteComplainStat == 0">无申诉</span>
              <span class="txt-status neutral" v-else-if="row.siteComplainStat == 3">待申诉</span>
              <span class="txt-status " v-else-if="row.siteComplainStat == 5">已申诉</span>
              <span class="txt-status " v-else-if="row.siteComplainStat == 7">中心已审核</span>
              <span class="txt-status disable" v-else-if="row.siteComplainStat == 8">中心驳回</span>
              <span class="txt-status " v-else-if="row.siteComplainStat == 9">总部已处理</span>
              <span class="txt-status disable" v-else-if="row.siteComplainStat == 99">取消</span>
            </template>

            <template #showRecallStat="{ row }">
              <span class="txt-status disable" v-if="row.recallStat == 0">未回访</span>
              <span class="txt-status neutral" v-else-if="row.recallStat == 1">已抽样</span>
              <span class="txt-status " v-else-if="row.recallStat == 2">已回访</span>
              <span class="txt-status " v-else-if="row.recallStat == 5">用户已评价</span>
            </template>

            <template #showStat="{ row }">
              <span class="txt-status " v-if="row.stat == 1">登记</span>
              <span class="txt-status " v-else-if="row.stat == 2">发布</span>
              <span class="txt-status " v-else-if="row.stat == 5">已派网点</span>
              <span class="txt-status " v-else-if="row.stat == 6">网点已接单</span>
              <span class="txt-status " v-else-if="row.stat == 9">已派师傅</span>
              <span class="txt-status " v-else-if="row.stat == 10">师傅已接单</span>
              <span class="txt-status " v-else-if="row.stat == 11">已预约</span>
              <span class="txt-status " v-else-if="row.stat == 13">已出发</span>
              <span class="txt-status " v-else-if="row.stat == 17">已上门</span>
              <span class="txt-status neutral" v-else-if="row.stat == 20">完工暂存</span>
              <span class="txt-status neutral" v-else-if="row.stat == 30">寄修待确认</span>
              <span class="txt-status neutral" v-else-if="row.stat == 31">待寄件</span>
              <span class="txt-status neutral" v-else-if="row.stat == 32">已寄待签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 36">待维修</span>
              <span class="txt-status neutral" v-else-if="row.stat == 37">修好待寄出</span>
              <span class="txt-status neutral" v-else-if="row.stat == 38">客户待签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 40">退换待确认</span>
              <span class="txt-status neutral" v-else-if="row.stat == 41">旧机待退回</span>
              <span class="txt-status neutral" v-else-if="row.stat == 42">旧机待签收</span>
              <span class="txt-status " v-else-if="row.stat == 43">旧机已签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 44">新机待寄出</span>
              <span class="txt-status " v-else-if="row.stat == 45">新机已寄出</span>
              <span class="txt-status neutral" v-else-if="row.stat == 47">新机待签收</span>
              <span class="txt-status " v-else-if="row.stat == 48">新机已签收</span>
              <span class="txt-status disable" v-else-if="row.stat == 49">退换被驳回</span>
              <span class="txt-status " v-else-if="row.stat == 61">已完工</span>
              <span class="txt-status " v-else-if="row.stat == 62">网点确认完工</span>
              <span class="txt-status neutral" v-else-if="row.stat == 63">中心完工审核</span>
              <span class="txt-status neutral" v-else-if="row.stat == 64">总部完工审核</span>
              <span class="txt-status neutral" v-else-if="row.stat == 91">待结算</span>
              <span class="txt-status disable" v-else-if="row.stat == 92">结算驳回</span>
              <span class="txt-status disable" v-else-if="row.stat == 93">结算中止</span>
              <span class="txt-status " v-else-if="row.stat == 94">已结算</span>
              <span class="txt-status disable" v-else-if="row.stat == 97">申请关闭</span>
              <span class="txt-status disable" v-else-if="row.stat == 98">挂起</span>
              <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
              <span class="txt-status disable" v-else-if="row.stat == 100">结束</span>

              <!-- <span v-if="row.urgeTimes > 0" class="txt-status reminder">{{ row.urgeTimes }}</span> -->


            </template>

            <template #showGuaranteeType="{ row }">
              <span class="txt-status " v-if="row.guaranteeType == 1">保内</span>
              <span class="txt-status disable" v-else-if="row.guaranteeType == 2">保外</span>
              <span class="txt-status neutral" v-else-if="row.guaranteeType == 3">未知</span>
            </template>


            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
            <template #option="{ row }">
              <div>
                <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id)">
                  <el-tooltip effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                    <i class="el-icon-edit" />
                  </el-tooltip>
                </a>

                <el-dropdown @command="handleCommand($event, row)">
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="assignSite && row.stat < 5" command="1">列表指派</el-dropdown-item>
                    <el-dropdown-item v-if="assignSiteByMap && row.stat < 5" command="2">地图指派</el-dropdown-item>
                    <el-dropdown-item v-if="assignOrg && row.stat == 2 && !row.orgId" command="3">指派中心
                    </el-dropdown-item>
                    <el-dropdown-item v-if="orderEdit && row.stat < 60" command="4">工单修改</el-dropdown-item>
                    <el-dropdown-item
                      v-if="orderFollowUp && isSite && ((6 <= row.stat && row.stat < 61) || row.stat == 98)"
                      command="5">工单跟进
                    </el-dropdown-item>
                    <el-dropdown-item v-if="orderFollowUp && !isSite && row.stat != 99" command="5">工单跟进
                    </el-dropdown-item>
                    <el-dropdown-item v-if="orderFinish && row.stat == 62" command="6">完工审核</el-dropdown-item>
                    <el-dropdown-item v-if="cancelCheck && row.stat == 97" command="7">取消审核</el-dropdown-item>
                    <el-dropdown-item v-if="assignAgain && row.stat >= 5 && row.stat < 61" command="8">重新派单
                    </el-dropdown-item>
                    <el-dropdown-item v-if="orderClose && row.stat < 11" command="99">关闭工单</el-dropdown-item>
                    <el-dropdown-item v-if="acceptOrder && row.stat == 5 && isSite" command="59">确认接单
                    </el-dropdown-item>
                    <el-dropdown-item v-if="acceptOrder && row.stat == 5 && isSite" command="69">退单</el-dropdown-item>
                    <el-dropdown-item v-if="siteCloseOrder && row.stat < 61 && row.stat >= 6 && isSite" command="70">申请关闭</el-dropdown-item>
                    <el-dropdown-item v-if="backOrder && row.stat < 61 && row.stat >= 6 && isSite" command="68">退回工单
                    </el-dropdown-item>
                    <el-dropdown-item  command="71" v-if="printOrder && (row.serviceType == 1 || row.serviceType ==2)">打印
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="assignEngineer && 6 <= row.stat && row.stat <= 11 && isSite && (!row.engineerId || row.engineerId == 0)"
                      command="60">派工程师
                    </el-dropdown-item>
                    <el-dropdown-item v-if="reAssignEngineer && 6 <= row.stat && row.stat <= 11 && isSite && (row.engineerId)"
                      command="65">
                      重新派工
                    </el-dropdown-item>
                    <!--                    <el-dropdown-item v-if="isSite" command="9">已派师傅</el-dropdown-item>-->
                    <el-dropdown-item v-if="assignSecondSite && 6 <= row.stat && row.stat <= 11 && isSite && row.bigSiteId"
                      command="61">派下级商
                    </el-dropdown-item>
                    <!--                    <el-dropdown-item v-if="isSite" command="62">已派网点</el-dropdown-item>-->
                    <!--                    <el-dropdown-item v-if="6<=row.stat && row.stat<=11 && isSite"  command="67">预约</el-dropdown-item>-->
                    <el-dropdown-item v-if="bookOrder && 6 <= row.stat && row.stat <= 20 && isSite" command="67">
                      {{
                        row.stat === 11 && (row.bookDatePeriod === null || row.bookDatePeriod === '') ? '终约' : '预约'
                      }}
                    </el-dropdown-item>
                    <el-dropdown-item v-if="finishOrder && 11 <= row.stat && row.stat <= 20 && isSite" command="63">完工
                    </el-dropdown-item>
                    <el-dropdown-item v-if="finishComfirmSite && row.stat == 61 && isSite" command="64">完工确认
                    </el-dropdown-item>
                    <el-dropdown-item v-if="rollbackOrderStat && row.stat == 98 && isSite" command="66">取消挂起
                    </el-dropdown-item>

                    <el-dropdown-item command="发起考核" v-if="toAddCheckBill && !isSite && row.siteName">
                      发起考核
                    </el-dropdown-item>
                    <el-dropdown-item v-if="orderSupervising" command="督办">督办</el-dropdown-item>
                    <!--                    <el-dropdown-item command="责任判定" v-if="!row.dutyJudge && orderJudging">责任判定</el-dropdown-item>-->
                    <!--                    <el-dropdown-item command="投诉处理" v-if="row.stat!=100 && orderComplaintHandling">投诉处理</el-dropdown-item>-->
                    <!--                    <el-dropdown-item command="服务商投诉处理" v-if="Number(row.stat) >= 6 && Number(row.stat) < 100 && siteOrderComplaintHandling && currentIsSite">投诉处理</el-dropdown-item>-->

                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <preconditionDialog v-if="showPreconditionDialog" :visiable.sync="showPreconditionDialog" multi="true" />


    <preconditionDialog2 v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" multi="true" />
    <!-- 列表指派 -->
    <zhiPaiDialog v-if="showAssignDialog" :visiable.sync="showAssignDialog" multi="true" :orderId="orderId"
      :assginType="assginType" @commitSiteRow="commitSiteRow" />
    <mapDialog v-if="showAssignByMapDialog" :visiable.sync="showAssignByMapDialog" multi="true" :param="assignSiteParam"
      :orderId="orderId" :assginType="assginType" @commitSiteRow="commitSiteRow" />
    <assignDialog v-if="showOrgDialog" @commitOrgSelect="commitOrgSelect" :visiable.sync="showOrgDialog" multi="true"
      :orderId="orderId" />
    <closeOrderDialog v-if="showCloseOrderDialog" @closeOrderRemark="closeOrderRemark"
      :visiable.sync="showCloseOrderDialog" multi="true" :orderId="orderId" />

    <batchCloseOrderDialog v-if="showBatchCloseOrderDialog" @closeOrderRemark="closeOrderRemark"
                      :visiable.sync="showBatchCloseOrderDialog" multi="true" :orderIds="orderIds" />
    <!-- 工单跟进 -->
    <orderRemark v-if="showOrderRemaekDialog" @followUpOrderRemark="followUpOrderRemark"
      :visiable.sync="showOrderRemaekDialog" :param="orderRemarkParam" />
    <!-- 完工确定 -->
    <completion v-if="completionDialog" @closeCompletionDialog="closeCompletionDialog" :visiable.sync="completionDialog"
      :param="orderRemarkParam" />
    <!-- 完工确定 -->
    <completionComfirm v-if="completComfirmDialog" @closeCompletComfirmDialog="closeCompletComfirmDialog"
      :visiable.sync="completComfirmDialog" :param="orderRemarkParam" />
    <!-- 确认接单 -->
    <siteAcceptDialog v-if="siteAcceptDialogShow" @closedispatchedAccept="closedispatchedAccept"
      :visiable.sync="siteAcceptDialogShow" :param="orderRemarkParam" />
    <!-- 申请关闭 -->
    <siteCloseOrderDialog v-if="siteCloseDialogShow" @closeOrderDialog="closeOrderDialog"
                      :visiable.sync="siteCloseDialogShow" :param="orderRemarkParam" />
    <!-- 退回工单 -->
    <backOrderDialog v-if="backOrderDialogShow" @closedispatchedBack="closedispatchedBack"
      :visiable.sync="backOrderDialogShow" :param="orderRemarkParam" />
    <!-- 派工程师 -->
    <dispatchEngineer v-if="dispatchEngineerDialog" @closeDispatchEngineer="closeDispatchEngineer"
      :visiable.sync="dispatchEngineerDialog" :param="orderRemarkParam" />
    <!-- 预约 -->

    <book v-if="bookDialog" @closeBook="closeBook" @closeD="closeD" :visiable.sync="bookDialog"
      :param="orderRemarkParam" />
    <!-- 已派师傅 -->
    <dispatchedMaster v-if="dispatchedMasterDialog" @closedispatchedMaster="closedispatchedMaster"
      :visiable.sync="dispatchedMasterDialog" :param="orderRemarkParam" />
    <!-- 派下级商-->
    <subcontractor v-if="subcontractorDialog" @closeSubcontractor="closeSubcontractor"
      :visiable.sync="subcontractorDialog" :param="orderRemarkParam" />
    <!-- 批量派下级商-->
    <batchSubcontractor v-if="batchSubcontractorDialog" @closeSubcontractor="closeSubcontractor"
                   :visiable.sync="batchSubcontractorDialog" :param="orderRemarkParam" />

    <!-- 已派网点 -->
    <dispatchedNetwork v-if="dispatchedNetworkDialog" @closedispatchedNetwork="closedispatchedNetwork"
      :visiable.sync="dispatchedNetworkDialog" :param="orderRemarkParam" />
    <!-- 修改工单 -->
    <orderEditDialog v-if="showOrderEditDialog" @closeEdit="closeEdit" :orderId="orderId"
      :visiable.sync="showOrderEditDialog" multi="true" />


    <cancelCheckDialog v-if="showCancelCheckDialog" @doCancelCheck="doCancelCheck" :visiable.sync="showCancelCheckDialog"
      :param="orderRemarkParam"></cancelCheckDialog>

    <!--发起考核-->
    <checkBillDialog v-if="showCheckBillDialog" @checkBillCommit="checkBillCommit"
                     :visiable.sync="showCheckBillDialog"
                     :param="rowData"></checkBillDialog>
    <orderPrintDialog v-if="showInstallPrintDialog" @closePrint ="closePrint"
                     :visiable.sync="showInstallPrintDialog" :orderIds="orderIds"
                        :orderId="orderId"></orderPrintDialog>


    <!--督办-->
    <supervising-dialog v-if="showSupervisingDialog" :visiable.sync="showSupervisingDialog" :row-data="rowData"
      @goBackIndex="getTableData" />

    <!--excel 模板导入 -->
    <excel-upload ref="excelUpload" title="工单信息导入" url="/basic/soOrder/import"
      temp-url="/admin/sys-file/local/file/orderInfo.xlsx" @refreshDataList="refreshChange"></excel-upload>
  </div>
</template>

<script>
import editView from '../common/edit.vue';
import preconditionDialog from '../common/dialog';
import preconditionDialog2 from '../common/dialog2.vue';
import mapDialog from '../common/mapdialog.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
import { doCheckExcle, doDownLoadExcle } from '@/api/intfDownloadRecord/downloadRecord.js'
import fileNames from "@/api/intfDownloadRecord/fileNames.js";

//列表指派
import zhiPaiDialog from '@/views/dialogCommon/assignSiteDialog.vue';
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import BrandSelect from "@/components/formItem/brandSelect.vue";
import ServiceTypeCascader from "@/components/formItem/serviceTypeCascader.vue";
import OrderTypeSelect from "@/components/formItem/orderTypeSelect.vue";
import DispatchStatSelect from "@/components/formItem/dispatchStatSelect.vue";

import assignDialog from "@/views/dialogCommon/orgDialog";
import closeOrderDialog from "@/views/dialogCommon/closeOrderDialog.vue";

import batchCloseOrderDialog from "@/views/dialogCommon/batchCloseOrderDialog.vue";
//工单跟进
import orderRemark from "@/views/dialogCommon/orderRemarkDialog";
//接单
import siteAcceptDialog from "@/views/dialogCommon/siteAcceptDialog.vue"
//网点关单
import siteCloseOrderDialog from "@/views/dialogCommon/siteCloseOrderDialog.vue";
//退单
import backOrderDialog from "@/views/dialogCommon/backOrderDialog.vue";
//完工确定
import completion from "@/views/dialogCommon/completionDialog.vue";
//完工确认
import completionComfirm from "@/views/dialogCommon/completComfirmDialog.vue";
//工单预约
import book from "@/views/dialogCommon/bookDialog.vue";
// 派工程师
import dispatchEngineer from "@/views/dialogCommon/dispatchEngineer.vue"
// 已派师傅
import dispatchedMaster from "@/views/dialogCommon/dispatchedMaster.vue"
// 派下级商
import subcontractor from "@/views/dialogCommon/subcontractor.vue"

// 批量派下级商
import batchSubcontractor from "@/views/dialogCommon/batchSbcontractor.vue"
//已派网点
import dispatchedNetwork from "@/views/dialogCommon/dispatchedNetwork.vue"
// 修改工单
import orderEditDialog from "./orderEditDialog.vue";


import orderPrintDialog from "./hdOrderlPrint.vue";

//取消审核
import cancelCheckDialog from "@/views/dialogCommon/orderCancelCheckDialog"
import store from "@/store";
import { siteMixins } from "@/mixins/tabChang";
import { mapState } from 'vuex';

import ExcelUpload from "@/components/upload/excel";
import { fetchList } from "@/api/admin/user";
import SiteOrderComplaintHandlingDialog
  from "@/views/workorder/business/complaintHandling/siteComplaintHandlingDialog.vue";
import OrderComplaintHandlingDialog from "@/views/workorder/business/complaintHandling/complaintHandlingDialog.vue";
import checkBillDialog from "@/views/workorder/business/complaintHandling/toCheckBillDialog.vue";
import OrderJudgingDialog from "@/views/workorder/business/complaintHandling/judgingDialog.vue";
import SupervisingDialog from "@/views/workorder/business/center/supervisingDialog.vue";
import {indexPageMixins} from "@/mixins/tabChang";
import request from "@/router/axios";

export default {
  inject: ['reload'],
  mixins: [indexPageMixins,siteMixins],
  name: 'information',
  components: {
    SupervisingDialog,
    OrderJudgingDialog, checkBillDialog, OrderComplaintHandlingDialog, SiteOrderComplaintHandlingDialog,

    DispatchStatSelect,
    OrderTypeSelect,
    ServiceTypeCascader,
    BrandSelect,
    SiteSearch,
    OrgSearch,
    editView,
    pager,
    preconditionDialog,
    preconditionDialog2,
    zhiPaiDialog,
    mapDialog,
    assignDialog,
    closeOrderDialog,
    batchCloseOrderDialog,
    completionComfirm,
    //完工确定
    completion,
    //接单
    siteAcceptDialog,
    //关单
    siteCloseOrderDialog,
    //退单
    backOrderDialog,
    //预约
    book,
    // 派工程师
    dispatchEngineer,
    // 已派师傅
    dispatchedMaster,
    // 派下级商
    subcontractor,
    // 批量派下级商
    batchSubcontractor,
    // 已派网点
    dispatchedNetwork,
    orderRemark,
    cancelCheckDialog,
    // 修改工单
    orderEditDialog,
    ExcelUpload,
    orderPrintDialog,

  },

  data() {
    return {
      bigSiteId: true,//是否一级服务商
      engineerList: [],
      editViewDataUpdateFlag: false,
      excelUpload: false,
      total: 0,
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      orderDealType: "",
      //权限管理
      assignOrg: false,
      orderEdit: false,
      assignSite: false,
      assignSites: false,
      soOrderImport: false,
      soOrderExport: false,
      rowData: null,

      orderClose: false,
      assignSiteByMap: false,
      acceptOrder: false,
      siteCloseOrder:false,
      backOrder: false,
      printOrder:false,
      reAssignEngineer: false,
      assignEngineer: false,
      bookOrder: false,
      assignSecondSite: false,
      finishComfirmSite: false,
      finishOrder: false,
      rollbackOrderStat: false,
      orderJudging: false,
      orderComplaintHandling: false,
      siteOrderComplaintHandling: false,
      orderFollowUp: false,
      orderFinish: false,
      showOrderEditDialog: false,
      areaObj: null,
      orderSupervising: false,
      toAddCheckBill: false,

      isShowAssign: true,
      isShowAccept: true,
      isShowClose: true,
      isShowAssignSecondSite: true,
      cancelCheck: false,
      assignAgain: false,
      requestParam: {
        engineerId: null,
        pageType: '工单处理',
        areaId: null,
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        stat: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        searchValue: null,
        orderNoArr:null,
        tabStat: null,

        serviceTypeId: null,
        partsStat: null,
        siteId: null,
        createBy: null,
        bookDateBegin: null,
        bookDateEnd: null,
        orderTypeId: null,
        outOrderNo: null,
        dispatchStat: null,

        orgIdPath: null,

        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        resultBarcode: '',//完工条码
        urgeTimesBegin:'',
        urgeTimesEnd:''
      },
      orderRemarkParam: {},
      assignSiteParam: {},
      //批量orderId
      orderIds: [],
      //指派类型0列表指派1批量指派2地图指派3重新指派
      assginType: 0,
      //工单跟进抽屉
      showOrderRemaekDialog: false,
      completionDialog: false,
      completComfirmDialog: false,
      bookDialog: false,
      dispatchEngineerDialog: false,

      dispatchedMasterDialog: false,
      siteAcceptDialogShow: false,
      siteCloseDialogShow:false,
      backOrderDialogShow: false,
      subcontractorDialog: false,
      batchSubcontractorDialog: false,
      dispatchedNetworkDialog: false,
      //取消审核抽屉
      showCancelCheckDialog: false,
      showOrderJudgingDialog: false,
      showOrderComplaintHandlingDialog: false,
      showSiteOrderComplaintHandlingDialog: false,
      showSupervisingDialog: false,
      showCheckBillDialog: false,
      //打印
      showInstallPrintDialog:false,
      isSite: null,
      formData: {
        engineerId: null,
        areaId: null,
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeDate: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        bookDate: null,
        bookDateBegin: null,
        bookDateEnd: null,
        searchValue: null,
        orderNoArr:null,
        partsStat: null,
        stat: null,
        orderTypeId: null,
        serviceTypeId: null,
        siteId: null,
        createBy: null,
        outOrderNo: null,
        managerName: null,
        siteName: null,
        dispatchStat: null,

        orgId: null,
        orgIdPath: null,
        orgName: null,
        resultBarcode: '',//完工条码
        urgeTimesBegin:'',
        urgeTimesEnd:''
      },
      show3: false,
      enableStat: false,
      sitePromptList: [],

      goodsStatusList: [ //循环列表
        { name: "所有", num: 0 },
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,
      showAssignDialog: false,
      showAssignByMapDialog: false,
      showCloseOrderDialog: false,
      showBatchCloseOrderDialog: false,

      orderId: "",
      serviceType:"",
      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 20, 100],

      showEdit: false,
      // 指派中心弹框
      showOrgDialog: false,
      columns: [
        { type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left' },
        { width: 100, field: 'status', fixed: 'right', title: this.$t('common.Controls'), showOverflow: true, slots: { default: 'option' } },
        {
          title: this.$t('common.WorkOrderNumber'), field: 'orderNo', width: 200, slots: {
            default: ({ row }) => {
              return [
                <span style="color: blue"
                  onClick={($event) => this.addressClickEvent(row, $event)}>{row.orderNo}</span>
              ]
            }
          }
        },
        { title: this.$t('common.ServiceType'), field: 'serverTypeName', width: 110, },
        { title: this.$t('common.status'), field: 'stat', width: 150, slots: { default: 'showStat' } },
        { title: this.$t('common.WorkOrderLabel'), field: 'dispatchStat', width: 80, },
        {
          title: this.$t('common.NumberReminders'), field: 'urgeTimes', width: 120, slots: {
            default: ({ row }) => {
              if(row.urgeTimes>0){
              return [<span>{row.urgeTimes}</span>
              ]}else  {
                return [
              0
                ];
              }
            }
          }
        },

        { title: this.$t('common.ContactPerson'), field: 'userName', width: 120, },
        { title: this.$t('common.contactNumber'), field: 'userMobile', width: 120, },
        { title: this.$t('common.brand'), field: 'brandName', width: 100, },
        { title: this.$t('common.ProductCategory'), field: 'bigCategoryName', width: 120, },
        { title:this.$t('common.WarrantyType'), field: 'guaranteeType', width: 120, slots: { default: 'showGuaranteeType' } },
        {
          title: this.$t('common.district'), field: 'area', width: 180, slots: {
            default: ({ row }) => {
              return [<span>{row.userProvice}{row.userCity}{row.userCounty}{row.userTown}</span>]
            }
          }
        },
        { title: this.$t('common.ServiceCenter'), field: 'orgName', width: 100, },
        { title: this.$t('common.BigServiceProvider'), field: 'bigSiteName', width: 100, },
        { title: this.$t('common.ServiceProvider'), field: 'siteName', width: 100, },
        { title: this.$t('common.Engineer'), field: 'engineerName', width: 100, },
        { title: this.$t('common.ReturnVisitStatus'), field: 'recallStat', width: 125, slots: { default: 'showRecallStat' } },
        { title: this.$t('common.founder'), field: 'createBy', width: 80, },
        { title: this.$t('common.CreationTime'), field: 'createTime', width: 150, },
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    // ...mapState(['clickMenu']),

  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {

      if (newVal === 'second') {
        this.orderDealType = ""
        if (this.editViewDataUpdateFlag) {
          this.getTableData()
        }
      }
    },
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.completeDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.completeTimeBegin = newVal[0]
          this.formData.completeTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.completeTimeBegin = null
          this.formData.completeTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.bookDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.bookDateBegin = newVal[0]
          this.formData.bookDateEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.bookDateBegin = null
          this.formData.bookDateEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    this.checkButton = this.permissions["checkButton"];
    this.assignOrg = this.permissions["assignOrg"];
    this.orderEdit = this.permissions["orderEdit"];
    this.assignSite = this.permissions["assignSite"];
    this.assignSites = this.permissions["assignSites"];
    this.orderClose = this.permissions["orderClose"];
    console.log("符合关闭:"+this.orderClose);
    this.assignSiteByMap = this.permissions["assignSiteByMap"];
    this.acceptOrder = this.permissions["acceptOrder"];
    this.siteCloseOrder = this.permissions["siteCloseOrder"];
    this.backOrder = this.permissions["backOrder"];
    this.reAssignEngineer = this.permissions["reAssignEngineer"];
    this.assignEngineer = this.permissions["assignEngineer"];
    this.bookOrder = this.permissions["bookOrder"];
    this.assignSecondSite = this.permissions["assignSecondSite"];
    this.finishComfirmSite = this.permissions["finishComfirmSite"];
    this.finishOrder = this.permissions["finishOrder"];
    this.rollbackOrderStat = this.permissions["rollbackOrderStat"];
    this.orderFollowUp = this.permissions["orderFollowUp"];
    this.orderFinish = this.permissions["orderFinish"];
    this.cancelCheck = this.permissions["cancelCheck"]
    this.assignAgain = this.permissions["assignAgain"]
    this.orderSupervising = this.permissions["orderSupervising"]
    this.toAddCheckBill = this.permissions["toAddCheckBill"]

    this.soOrderImport = this.permissions["soOrderImport"]
    this.soOrderExport = this.permissions["soOrderExport"]
    this.printOrder = this.permissions["printOrder"]

    console.log(this.currentIsSite, this.dataId2, "this.currentIsSite的值");
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      this.isSite = true;
      console.log("网点信息", this.currentSiteData)
      if(this.currentSiteData.snSiteInfoDTO.siteFloorLevel == 1){
        this.bigSiteId = true;
      }else {
        this.bigSiteId = false;
      }
    }
    console.log("此处用户的主要信息为:",userInfo)
    if (this.isSite) {

    }
  },

  mounted() {
    this.initSearchDate()
    this.getEngineerList()
  },

  methods: {

    engineerSelectChang(){

    },

    // 加载服务商工程师
    getEngineerList() {
      if(!this.isSite){
        return;
      }
      this.$http.post(api.snSiteEngineer.getSiteEngineerList, {}).then(res => {
        this.engineerList = []
        res.data.data.forEach(item => {
          this.engineerList.push({
            label: item.engineerName,
            value: item.id
          })
        })
        console.log("工程师数据:",this.engineerList)
      })
    },

    closeEdit() {
      console.log(777);
      // this.$refs.pager.reset()  // 重置分页器
      // this.getTableData()
      this.$refs['table-m1'].commitProxy('reload');
    },
    refreshChange() {
      this.getTableData()
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createDate = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },


    // 加载tab数据
    async loadTabOption() {
      await this.$http.post(api.soOrder.getCountUrl, this.requestParam).then(res => {
        this.goodsStatusList = res.data.data
        if (this.goodsStatusList && this.goodsStatusList.length > 0 && this.requestParam.tabStat == null) {
          this.requestParam.tabStat = "所有"
          if (this.$route.query.index) {
            // 首页跳转打开
            let sub = this.$route.query.index
            this.goodsStatusIndex = sub
            let name = this.goodsStatusList[sub]
            console.log(name, sub, "this.goodsStatusList(sub),sub点击的值")
            this.changeGoodsStatus(name, sub)
          } else {
            // 默认直接打开
            this.goodsStatusIndex = this.goodsStatusList.length - 1
          }

        }
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      console.log('goodsStatusItem', this.goodsStatusItem)
      this.requestParam.tabStat = this.goodsStatusItem
      this.enableStat = item.name === '所有'
      if (this.goodsStatusItem == '完工待审核' || this.goodsStatusItem == '取消待审核') {
        this.isShowAssign = false;
      } else {
        this.isShowAssign = true;
      }
      if (this.goodsStatusItem == '待接单') {
        this.isShowAccept = true;
      } else {
        this.isShowAccept = false;
      }

      if (this.goodsStatusItem == '待接单' || this.goodsStatusItem == '待初约' || this.goodsStatusItem == '待派工程师'
      || this.goodsStatusItem == '待派中心' || this.goodsStatusItem == '待派服务商' || this.goodsStatusItem == '超期7天') {
        this.isShowClose = true;
        console.log("符合条件")
      } else {
        this.isShowClose = false;
        console.log("不符合条件")
      }

      if (this.goodsStatusItem == '待初约' || this.goodsStatusItem == '待派工程师' || this.goodsStatusItem == '待终约') {
        this.isShowAssignSecondSite = true;
        console.log("符合条件")
      } else {
        this.isShowAssignSecondSite = false;
        console.log("不符合条件")
      }

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器

      this.getTableData()
    },

    // // 加载品牌
    // loadBrandOption() {
    //   this.$http({
    //     url: api.snCompanyBrand.getBrandListUrl,
    //     method: 'post',
    //     data: {
    //       usable: 1  // 加载启用的
    //     }
    //   }).then(res => {
    //     this.brandOptions = [{label: '全部', value: null}]
    //     res.data.data.forEach(item => {
    //       this.brandOptions.push({
    //         label: item.brandName,
    //         value: item.id
    //       })
    //     })
    //   })
    // },

    checkBillCommit(type) {
      this.showCheckBillDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },

    // 加载table数据
    async getTableData() {

      await this.loadTabOption()
      this.requestParam.pageType = '工单处理'
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.soOrder.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },
    closeD(type) {
      this.bookDialog = false;
      this.flushed()


    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },


    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleAreaChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.formData.areaId = areaNode[0].value
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },


    ///////////////////////////////////////////////////////////////////////////////////////////////////


    addressClickEvent(row, id) {
      this.openEditDialog(row.id);
      console.log(row, id, "row");
    },
    // 选中的按钮

    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.flushed()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.flushed()// 需要刷新页面
      });

    },
    // 操作下拉选
    handleCommand(type, row) {
      if (type == 1) {
        //列表指派
        this.orderId = row.id;
        this.orderIds = [];
        this.assginType = 0
        this.showAssignDialog = true;
      } else if (type == 2) {
        //地图指派
        this.orderId = row.id;
        this.orderIds = [];
        this.assginType = 2
        this.assignSiteParam.wishBookDate = row.wishBookDate
        this.showAssignByMapDialog = true;

      } else if (type == 3) {
        //指派中心
        this.orderId = row.id;
        this.showOrgDialog = true;
      } else if (type == 4) {
        //修改工单
        this.orderId = row.id;
        this.showOrderEditDialog = true
        // this.activeName = 'first';
        // this.orderDealType = "orderEdit"
        // this.$openEditView('showEdit');

      } else if (type == 5) {
        //工单跟进
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.showOrderRemaekDialog = true;

      } else if (type == 6) {
        //完工审核
        this.dataId = row.id;
        this.activeName = 'first';
        this.orderDealType = "orderFinish"
        this.$openEditView('showEdit');

      } else if (type == 7) {
        //取消审核
        this.orderRemarkParam.orderId = row.id
        this.showCancelCheckDialog = true;
      } else if (type == 8) {
        //重新指派
        this.orderId = row.id;
        this.orderIds = [];
        this.assginType = 3
        this.showAssignDialog = true;
      } else if (type == 9) {
        // 已派师傅
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.dispatchedMasterDialog = true;
      } else if (type == 59) {
        //确认接单
        this.orderId = row.id;
        this.siteAccept();
      } else if (type == 60) {
        //派工程师
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.dispatchEngineerDialog = true;

      } else if (type == 61) {
        // 派下级商
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.subcontractorDialog = true;

      } else if (type == 62) {
        // 已派网点
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.dispatchedNetworkDialog = true;

      } else if (type == 63) {
        //网点完工
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.completionDialog = true;
      } else if (type == 64) {
        //确认完工
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.completComfirmDialog = true;
      } else if (type == 65) {
        //重新派工
        this.orderId = row.id;
        this.handleReAssignEngineer();
      } else if (type == 66) {
        //取消挂起
        this.orderId = row.id;
        this.cancelOrder();
      } else if (type == 67) {
        //预约
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.bookDialog = true;
      } else if (type == 68) {
        //退单
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.backOrderDialogShow = true;
      } else if (type == 69) {
        //拒单
        this.orderRemarkParam.showInRemark = 1
        this.orderRemarkParam.orderId = row.id
        this.siteAcceptDialogShow = true;
      }else if (type == 70) {
          //申请关单
          this.orderRemarkParam.showInRemark = 1
          this.orderRemarkParam.orderId = row.id
          this.siteCloseDialogShow = true;
      }else if (type == 71) {
        //打印
        this.orderId = row.id;
        this.orderIds =''
        this.showInstallPrintDialog  = true
      } else if (type == 99) {//关闭工单
        this.orderId = row.id;
        this.showCloseOrderDialog = true;
      } else if (type === '责任判定') {
        this.showOrderJudgingDialog = true
        this.rowData = row
      } else if (type === '投诉处理') {
        this.showOrderComplaintHandlingDialog = true
        this.rowData = row
      } else if (type === '发起考核') {
        this.showCheckBillDialog = true
        this.rowData = row
      } else if (type === '服务商投诉处理') {
        this.showSiteOrderComplaintHandlingDialog = true
        this.rowData = row
      } else if (type === '督办') {
        this.rowData = row
        this.showSupervisingDialog = true
      }
    },
    closePrint(type) {
      if (type == 1) {
        this.showInstallPrintDialog = false;
      }
    },
    //批量打印
    doPrints() {
      let orderIds = [];
      const checkIds = this.$refs['table-m1'].getCheckboxRecords();
      for (let i = 0; i < checkIds.length; i++) {
          orderIds.push(checkIds[i].id)
      }
      if (orderIds.length == 0) {
        this.$message.error('请先选择需要批量打印的单据！')
        return
      }

      this.orderIds = orderIds;
      this.orderId = orderIds[0];
      this.showInstallPrintDialog  = true
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
      this.activeName = 'second';
    },
    //批量指派
    doAssignSites() {
      let orderIds = [];
      const checkIds = this.$refs['table-m1'].getCheckboxRecords();
      if (checkIds.length == 0) {
        this.$message.error('请先选择需要批量指派的单据！')
        return
      }
      for (let i = 0; i < checkIds.length; i++) {
        orderIds.push(checkIds[i].id)
      }
      this.orderIds = orderIds;
      this.orderId = orderIds[0];
      this.assginType = 1
      this.showAssignDialog = true;
    },
    doAssignSitesByMay() {
      let orderIds = [];
      const checkIds = this.$refs['table-m1'].getCheckboxRecords();
      if (checkIds.length == 0) {
        this.$message.error('请先选择需要地图指派的单据！')
        return
      }
      if (checkIds.length >1) {
        this.$message.error('地图指派不允许指派多个单据！')
        return
      }
      for (let i = 0; i < checkIds.length; i++) {
        orderIds.push(checkIds[i].id)
      }
      this.orderIds = orderIds;
      this.orderId = orderIds[0];
      this.orderIds = [];
      this.assginType = 2
      this.assignSiteParam.wishBookDate = checkIds[0].wishBookDate
      this.showAssignByMapDialog = true;
    },
    //网点接单
    siteAccept(row) {
      this.$baseConfirm('是否确认接单？').then(() => {
        this.$http({
          url: api.soOrder.siteAcceptUrl,
          method: 'post',
          data: {
            id: this.orderId,
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          this.flushed()// 需要刷新页面
        })
      });
    },

    bathOrderClose(){
      let orderIds = [];
      const checkIds = this.$refs['table-m1'].getCheckboxRecords();
      if (checkIds.length == 0) {
        this.$message.error('请先选择需要关闭的单据！')
        return
      }
      for (let i = 0; i < checkIds.length; i++) {
        orderIds.push(checkIds[i].id)
      }
      this.orderIds = orderIds;
      this.showBatchCloseOrderDialog = true;
    },

    //批量派下级商
    batchAssignSecondSite(){
      let orderIds = [];
      const checkIds = this.$refs['table-m1'].getCheckboxRecords();
      if (checkIds.length == 0) {
        this.$message.error('请先选择需要派下级商的单据！')
        return
      }
      for (let i = 0; i < checkIds.length; i++) {
        orderIds.push(checkIds[i].id)
      }
      this.orderIds = orderIds;
      this.batchSubcontractorDialog = true;
      this.orderRemarkParam.showInRemark = 1
      this.orderRemarkParam.orderIds = this.orderIds
    },

    siteAccepts() {
      let orderIds = [];
      const checkIds = this.$refs['table-m1'].getCheckboxRecords();
      if (checkIds.length == 0) {
        this.$message.error('请先选择需要进行接单的单据！')
        return
      }
      for (let i = 0; i < checkIds.length; i++) {
        orderIds.push(checkIds[i].id)
      }
      this.orderIds = orderIds;

      this.$confirm('是否确认全部接单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$mask.open()
        this.$http({
          url: api.soOrder.siteAcceptsUrl,
          method: 'post',
          data: {
            orderIds: orderIds
          },
        }).then(res => {
          if (res.data.type) {
            this.$message.success('操作成功')
            this.$mask.close()
            this.flushed()// 需要刷新页面
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        });
      });
      this.$mask.close()
    },
    //重新派工
    handleReAssignEngineer() {
      this.$baseConfirm('是否重新派工？').then(() => {
        this.$http({
          url: api.soOrder.reAssignEngineerUrl,
          method: 'post',
          data: {
            id: this.orderId,
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          this.flushed()// 需要刷新页面
        })
      });
    },
    //取消挂起
    cancelOrder(row) {
      this.$baseConfirm('您确定要取消挂起工单吗？').then(() => {
        this.$http({
          url: api.soOrder.cancelOrderUrl,
          method: 'post',
          data: {
            id: this.orderId,
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
          this.flushed()// 需要刷新页面
        })
      });
    },
    //指派确认
    commitSiteRow(row) {
      this.$http({
        url: api.soOrder.assignSiteUrl,
        method: 'post',
        data: {
          orderId: this.orderId,
          orderIds: this.orderIds,
          siteId: row.id,
          type: row.callBackAssignType,
          isSendSite: row.isSendSite,
          isSendUser: row.isSendUser
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$message({
          type: response.data.type,
          message: response.data.content
        });

      })
      this.flushed()// 需要刷新页面
    },
    //关闭工单回调方法
    closeOrderRemark(type) {
      this.showCloseOrderDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },
    followUpOrderRemark(type) {
      this.showOrderRemaekDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },
    //取消审核回调方法
    doCancelCheck(type) {
      this.showCancelCheckDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },
    //接单
    closedispatchedAccept(type) {
      this.siteAcceptDialogShow = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },
    //接单
    closeOrderDialog(type) {
      this.siteCloseDialogShow = false;
    },
    //退单
    closedispatchedBack(type) {
      this.backOrderDialogShow = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },

    // 已派师傅
    closedispatchedMaster(type) {
      this.dispatchedMasterDialog = false;
    },
    // 已派网点
    closedispatchedNetwork(type) {
      this.dispatchedNetworkDialog = false;

    },
    //完工
    closeCompletionDialog(type) {
      this.completionDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },
    //确认完工
    closeCompletComfirmDialog(type) {
      this.completComfirmDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },
    // 派工程师
    closeDispatchEngineer(type) {
      this.dispatchEngineerDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },
    //关闭派下级商
    closeSubcontractor(type) {
      this.batchSubcontractorDialog = false;
      this.subcontractorDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },
    // // 派工程师
    closeBook(type) {
      this.bookDialog = false;

      this.flushed()// 需要刷新页面

    },
    //指派机构确认
    commitOrgSelect(data) {
      this.$http({
        url: api.soOrder.assignOrgUrl,
        method: 'post',
        data: {
          orgId: data.id,
          id: data.orderId,
          orgName: data.name,
          orgIdPath: data.orgIdPath
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$message({
          type: response.data.type,
          message: response.data.content
        });
        this.flushed()// 需要刷新页面
      })
    },
    // 打开执行考核弹窗
    handleCommand2(command, b) {
      console.log(command, b, "command,b的值");
      this.$message('click on item ' + b);
      if (b == 1) {
        this.showPreconditionDialog2 = true;
      } else if (b == 2) {
        this.open()
      }
    },
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.flushed()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.flushed()// 需要刷新页面
      });

    },
    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },

    // // 分页功能
    // changeTablePage(page, flag) {
    //   console.log('分页数据', page, this.formData)
    //   this.formData.size = page.pageSize
    //   this.formData.current = page.currentPage
    //   this.formData.searchCount = flag
    //   this.initTableList();
    // },
    // // 搜索
    // searchEvent() {
    //   this.$refs['table-m1'].commitProxy('reload');
    //
    // },
    // // 重置
    // resetEvent() {
    //   this.formData = {};
    //   this.formData.addresswangdian = {};
    //   this.$refs['table-m1'].commitProxy('reload');
    // },
    // 新增
    openEditDialog(id) {

      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log(this.dataId, '触发了跳转');
    },

    //导出
    doExcle() {
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.order).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle(api.soOrder.doExcelUrl, this.formData).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      })
    },

    initTableList() {
      let that = this;
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.soOrder.getTableDataUrl,
        param: this.formData,
        method: 'post',


      };
      // initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);

      this.$refs['table-m1'].commitProxy('reload');
    },


  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}



::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}



::v-deep .el-cascader--medium {

  height: 38px;
}



// 最上面需求
.box{
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
}
.box1{
height: 80px;
width: 32%;
border:1px solid #4190AE;
margin-right: 5px;
border-radius: 10px;
// background-color:#ededed;
}

.box1_item1{
  text-align: center;
    width: 33%;
    height: 20px;
    margin: 0px auto;
    background-color: #fff;
    position: relative;
    top: -10px;
}
.box1_item2{
  display: flex;
  justify-content: space-between;
    align-items: center;
  color: #fff;
  font-size: 30px;
}
.box1_item2_title{
  width:31%;
  border-radius: 10px;
    text-align: center;
    line-height: 60px;
    height: 55px;
}
.box1_item2_title1{
  background-color:#86C189;
  margin-left:5px;

 
}
.box1_item2_title2{
  background-color:#FFC000;


  

 
}
.box1_item2_title3{
  background-color:#FF0000;

 
  margin-right: 5px;


}
</style>
